import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
} from "@mui/material";
import axios, { AxiosError } from "axios";
import { id } from "date-fns/locale";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { queryClient } from "../App";
import { API_URL } from "../consts";
import KeyIcon from "@mui/icons-material/Key";

interface Data {
  id: number;
  email: string;
}
interface CreateClubAdmin {
  clubId: number;
  email: string;
  password: string;
}

export function ClubAdmins(props: { clubId: string }) {
  const { clubId } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");

  const [pwdId, setPwdId] = useState(-1);
  const [emailPwd, setEmailPwd] = useState("");
  const [openPwd, setOpenPwd] = useState(false);

  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };
  const handleChangePassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };
  const handleChangePassword2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword2(event.target.value);
  };

  const { isLoading, data } = useQuery<unknown, AxiosError, { admins: Data[] }>(
    ["users/getAdmins", id],
    () => axios.get(API_URL + "users/getAdmins/" + clubId).then((res) => res.data)
  );
  const { mutate } = useMutation(
    (data: CreateClubAdmin) => {
      return axios.post(API_URL + "users/createClubAdmin", data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Club Admin Creato", { variant: "success" });
        handleClose();
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );
  const { mutate: changePsw } = useMutation(
    () => {
      return axios.post(API_URL + "users/changeClubAdminPassword/" + pwdId, { password });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Password modificata", { variant: "success" });
        handleClose();
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const handleSubmit = () => {
    if (password !== password2)
      enqueueSnackbar("Le password devono essere uguali!", { variant: "error" });
    else {
      const data = {
        clubId: parseInt(clubId),
        email,
        password,
      };
      mutate(data);
    }
  };

  const changeClick = (id: number, email2: string) => {
    setPwdId(id);
    setEmailPwd(email2);
    setOpenPwd(true);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenPwd(false);
    setEmail("");
    setEmailPwd("");
    setPwdId(-1);
    setPassword("");
    setPassword2("");
  };

  const handleSubmitPsw = () => {
    if (password !== password2)
      enqueueSnackbar("Le password devono essere uguali!", { variant: "error" });
    else {
      changePsw();
    }
  };

  return (
    <>
      <Button color="secondary" onClick={handleClickOpen}>
        Aggiungi Admin
      </Button>
      <TableContainer>
        <Table size="small">
          {!isLoading &&
            data?.admins.map((e) => (
              <TableRow>
                <TableCell sx={{ width: 30 }}>
                  <IconButton onClick={() => changeClick(e.id, e.email)}>
                    <KeyIcon />
                  </IconButton>
                </TableCell>
                <TableCell>{e.email}</TableCell>
              </TableRow>
            ))}
        </Table>
      </TableContainer>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Aggiungi Club Admin</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Email"
            type="email"
            fullWidth
            variant="standard"
            value={email}
            onChange={handleChangeEmail}
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Password"
            type="password"
            fullWidth
            variant="standard"
            value={password}
            onChange={handleChangePassword}
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Ripeti Password"
            type="password"
            fullWidth
            variant="standard"
            value={password2}
            onChange={handleChangePassword2}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmit} autoFocus>
            Aggiungi
          </Button>
          <Button onClick={handleClose} autoFocus>
            Chiudi
          </Button>
        </DialogActions>
      </Dialog>
      {/*  */}
      <Dialog open={openPwd} onClose={handleClose}>
        <DialogTitle>
          Modifica Password <br />
          {emailPwd}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Password"
            type="password"
            fullWidth
            variant="standard"
            value={password}
            onChange={handleChangePassword}
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Ripeti Password"
            type="password"
            fullWidth
            variant="standard"
            value={password2}
            onChange={handleChangePassword2}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmitPsw} autoFocus>
            Modifica
          </Button>
          <Button onClick={handleClose} autoFocus>
            Chiudi
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
